export function joinNames(items: ReadonlyArray<{ name: string }>): string {
  return items.map((item: { name: string }): string => item.name).join(', ');
}
